export default function makeLinksTargetBlank(element) {
  const iFrameBodyOrElement =
    (element.contentDocument ? element.contentDocument : element.contentWindow?.document) ?? element;
  if (!iFrameBodyOrElement) return;
  [...iFrameBodyOrElement.querySelectorAll("a")].forEach((a) => {
    a.target = "_blank";
    a.rel = "noopener";
  });
}
